import { ReactNode, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import { useAlertPanelStyles } from './alert-panel.styles';

type Severity = 'error' | 'success' | 'warning';

export type AlertPanelProps = {
  title: string;
  description?: string | ReactNode;
  severity?: Severity;
  defaultExpanded?: boolean;
  extraDetails?: ReactNode;
  shouldClose?: boolean;
};

export function AlertPanel({
  title,
  description,
  severity = 'error',
  defaultExpanded = false,
  extraDetails,
  shouldClose = false,
}: AlertPanelProps) {
  const classes = useAlertPanelStyles({ severity });
  const [openAlert, setOpenAlert] = useState(true);
  const [openErrorDesc, setOpenErrorDesc] = useState(defaultExpanded);

  return (
    <>
      {openAlert && (
        <Box className={classes.container}>
          <Box className="leftBorder" />

          <Box className="mainWrapper">
            <Box className="shortInfoWrapper">
              <Box className="contentWrapper">
                {severity === 'error' && (
                  <ErrorIcon fontSize="medium" color="error" />
                )}
                {severity === 'warning' && (
                  <WarningIcon fontSize="medium" color="warning" />
                )}
                {severity === 'success' && (
                  <CheckCircleIcon fontSize="medium" color="success" />
                )}

                <Typography
                  variant="caption"
                  component="span"
                  className="errorTitle"
                >
                  {title}
                </Typography>
                {description && (
                  <>
                    <Box className="separator" />

                    <Box
                      className="showDetailsWrapper"
                      onClick={() => setOpenErrorDesc(!openErrorDesc)}
                    >
                      <Typography
                        variant="caption"
                        component="span"
                        className="showDetails"
                      >
                        Show details
                      </Typography>
                      {openErrorDesc ? (
                        <ExpandLessIcon className="moreIcon" fontSize="small" />
                      ) : (
                        <ExpandMoreIcon className="moreIcon" fontSize="small" />
                      )}
                    </Box>
                  </>
                )}
              </Box>
              {shouldClose && (
                <CloseIcon
                  onClick={() => setOpenAlert(false)}
                  className="closeIcon"
                  fontSize="small"
                />
              )}
            </Box>

            {openErrorDesc && description && (
              <Box className="detailsInfoWrapper">
                <Typography
                  variant="caption"
                  component="span"
                  className="detailsInfo"
                >
                  {description}
                </Typography>
                {extraDetails}
              </Box>
            )}
          </Box>
        </Box>
      )}
    </>
  );
}
